<template>
  <div v-loading="loading">
    <div
      class="header-top basic-header"
      :class="{
        'box-shadow': isHeaderShadow,
        'header-visible': isHeaderVisible,
      }"
    >
      <div class="left">
        <div @click="$router.go(-1)" class="header-back">
          <svg-icon class="header-svg" icon-class="left-arrow" />
        </div>
        <transition name="el-fade-in-linear">
          <span v-show="!isScrollShow">{{ headerText }}</span>
        </transition>
      </div>
      <transition name="el-fade-in-linear">
        <div class="scroll-box" v-show="isScrollShow">
          <div class="left-scroll">
            <el-image
              v-if="companyStore.photoUrl"
              class="head-img"
              :src="companyStore.photoUrl"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i></div
            ></el-image>
            <div class="scroll-main">
              <div class="scoll-name">{{ companyStore.name }}</div>
              <div class="scroll-post">
                {{ companyStore.typeVal | nullValue }}
              </div>
            </div>
          </div>
          <div class="right-scroll">
            <!-- <el-button>关黑</el-button> -->
          </div>
        </div>
      </transition>
    </div>
    <div class="basic-info">
      <div class="basic-head">
        <div class="head-main">
          <div class="main-left" :class="{ 'z-index': !isTagsShow }">
            <div class="head-box">
              <el-image
                class="head-img"
                :src="companyStore.photoUrl"
                fit="cover"
                ><div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i></div
              ></el-image>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                :http-request="getFile"
                :before-upload="beforeAvatarUpload"
                list-type="picture"
                :show-file-list="false"
                id="headUpload"
              >
                <div class="head-btn">更换头像</div>
              </el-upload>
              <div class="head-loading" v-if="isLoading">
                <i class="el-icon-loading"></i>上传中
              </div>
            </div>
            <div class="head-items">
              <div class="head-item">
                <span class="basic-name">{{ companyStore.name }}</span>
              </div>
              <!-- <div>{{ companyStore.typeVal | nullValue }}</div> -->
              <div class="encrypt-number">
                <span v-if="!hideInfo.headerPhone"
                  >联系电话：{{ companyStore.phoneNumber }}</span
                >
                <span v-else>
                  <span v-if="companyStore.phoneNumber">
                    联系电话：{{
                      companyStore.phoneNumber.substring(0, 3)
                    }}****{{
                      companyStore.phoneNumber.substring(
                        companyStore.phoneNumber.length - 4
                      )
                    }}
                  </span>
                  <span v-else>联系电话： —</span>
                </span>
                <div class="show-svg" @click="authLook('headerPhone')"  v-if="companyStore.phoneNumber">
                  <svg-icon icon-class="hidden" v-if="!hideInfo.headerPhone" />
                  <svg-icon icon-class="show" v-else />
                </div>
              </div>
              <div>
                分销商门店维护人：<span
                  v-if="companyStore.user && companyStore.user.name"
                  >{{ companyStore.user.name | nullValue }}</span
                >
                <span v-else>—</span>
              </div>
              <div class="head-tags">
                <div class="head-item tags-box" v-if="isTagsShow">
                  <div class="tags-items">
                    <div
                      class="tag"
                      v-for="(item, index) in companyStore.tags"
                      v-show="index < tagNum"
                      :key="index"
                    >
                      {{ item }}
                    </div>
                    <div class="tag" v-if="companyStore.tags.length > tagNum">
                      ...
                    </div>
                  </div>
                  <span class="tag-btn" @click="addTag">添加标签</span>
                </div>
                <div v-else class="tags-input">
                  <div class="input-box">
                    <div
                      class="tag"
                      v-for="(item, index) in companyStore.tags"
                      :key="index"
                    >
                      <span class="tag-text">{{ item }}</span>
                      <span @click="delTag(index)">
                        <svg-icon icon-class="tag-del" />
                      </span>
                    </div>
                    <el-input
                      v-model="headTag"
                      @change="submitTag(true)"
                      maxlength="7"
                      v-if="companyStore.tags.length < 5"
                    ></el-input>
                  </div>
                  <span class="input-btn" @click="submitTag(false)">保存</span>
                </div>
              </div>
            </div>
          </div>
          <div class="main-right">
            <div class="right-items">
              <div>
                分销商门店类型
                <div class="item-value">{{ companyStore.typeVal }}</div>
              </div>
              <div>
                是否主店
                <div class="item-value">
                  {{ companyStore.isMaster ? "是" : "否" | nullValue }}
                </div>
              </div>
              <div>
                分销商门店状态
                <div class="item-value">{{ companyStore.statusVal }}</div>
              </div>
            </div>
            <div class="right-btns" v-show="isTagsShow">
              <!-- <el-button>关黑</el-button> -->
            </div>
          </div>
        </div>
        <div class="head-line"></div>
        <div class="head-bottom">
          <div class="bottom-left" @click="editRemarks">
            <span v-if="companyStore.more">{{ companyStore.more }}</span>
            <span v-else>添加分销商门店备注</span>
            <span class="mark-box">
              <svg-icon icon-class="edit" />
            </span>
          </div>
          <div class="bottom-right">
            <el-tooltip
              placement="top"
              popper-class="custom-tooltip"
              effect="light"
            >
              <div slot="content">打印</div>
              <span>
                <svg-icon icon-class="print" />
              </span>
            </el-tooltip>
            <!-- <el-tooltip
              placement="top"
              popper-class="custom-tooltip"
              effect="light"
            >
              <div slot="content">下载</div>
              <span>
                <svg-icon icon-class="derive-ico" />
              </span>
            </el-tooltip> -->
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <el-form
        label-position="left"
        label-width="10rem"
        :rules="companyStoreRules"
        :model="companyStore"
        ref="companyStoreForm"
      >
        <!-- 基本信息 -->
        <div class="basic-item">
          <div v-if="isEditBasic">
            <div class="basic-item-title">基本信息</div>
            <div class="basic-item-main">
              <!-- 左 -->
              <div class="main-item">
                <el-form-item label="分销商门店名称" prop="name">
                  <el-input
                    v-model="companyStore.name"
                    placeholder="请输入分销商门店名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="分销商门店类型" prop="type">
                  <el-select
                    v-model="companyStore.type"
                    clearable
                    placeholder="请选择分销商门店类型"
                  >
                    <el-option
                      v-for="item in companyStoreTypeOptions"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="选择组织" prop="organizationId">
                  <el-select
                    v-model="companyStore.organizationId"
                    filterable
                    remote
                    placeholder="请输入组织关键词"
                    @focus="getOrganization('')"
                    :remote-method="getOrganization"
                    :loading="getOrgLoading"
                  >
                    <el-option
                      v-for="item in orgList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话" prop="phoneNumber">
                  <el-input
                    v-model="companyStore.phoneNumber"
                    placeholder="请输入联系电话"
                    clearable
                  ></el-input>
                  
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                  <el-input
                    v-model="companyStore.email"
                    placeholder="请输入电子邮箱"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否主店" prop="isMaster">
                  <el-radio-group v-model="companyStore.isMaster">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <!-- 右 -->
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item label="分销商门店租金" prop="rent">
                  <el-input
                    v-model="companyStore.rent"
                    placeholder="请输入分销商门店租金"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="分销商门店面积" prop="area">
                  <el-input
                    v-model="companyStore.area"
                    placeholder="请输入分销商门店面积"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="分销商门店退出方式" prop="dropWay">
                  <el-radio-group v-model="companyStore.dropWay">
                    <el-radio
                      v-for="(item, index) in companyStoreDropWayOptions"
                      :key="index"
                      :label="item.option"
                      >{{ item.option }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="分销商门店退出时间" prop="dropTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.dropTime"
                    type="date"
                    placeholder="请选择分销商门店退出时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="歇业开始时间" prop="closeStartTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.closeStartTime"
                    type="date"
                    placeholder="请选择歇业开始时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="歇业结束时间" prop="closeEndTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.closeEndTime"
                    type="date"
                    placeholder="请选择歇业结束时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="submit('basic')"
                >保存</el-button
              >
              <el-button @click="cancel()">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              基本信息
              <div class="basic-edit" @click="isEditBasic = true">管理</div>
            </div>
            <div class="basic-item-main">
              <!-- 左 -->
              <div class="main-item">
                <el-form-item label="分销商门店名称" prop="name">
                  {{ companyStore.name | nullValue }}
                </el-form-item>
                <el-form-item label="分销商门店类型" prop="type">
                  {{ companyStore.typeVal | nullValue }}
                </el-form-item>
                <el-form-item label="关联组织" prop="organizationId">
                  <span v-if="companyStore.organization&&companyStore.organization.name">{{ companyStore.organization.name | nullValue }}</span>
                  <span v-else>—</span>
                </el-form-item>
                <el-form-item
                  v-if="companyStore.organizationId"
                  label="维护人"
                  prop="user"
                >
                  <div class="job-num-box">
                    <p v-if="!isEditUser">
                      <span
                        v-if="companyStore.user && companyStore.user.name"
                        >{{ companyStore.user.name | nullValue }}</span
                      >
                      <span v-else>—</span>
                    </p>
                    <div v-else>
                      <el-select
                        v-model="companyStore.userId"
                        filterable
                        remote
                        placeholder="请输入维护人关键词"
                        @focus="getUser('')"
                        :remote-method="getUser"
                        :loading="getUserLoading"
                        style="width: 180px"
                      >
                        <el-option
                          v-for="item in userList"
                          :key="item.id"
                          :label="item.name || '匿名'"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div v-if="permissions['Company.Stores.BindingForUser']">
                      <div
                        v-if="!isEditUser"
                        class="job-num-btn"
                        @click="isEditUser = true"
                      >
                        指派维护人
                      </div>
                      <div v-else>
                        <span
                          class="job-num-btn"
                          @click="changeUser(companyStore.userId)"
                        >
                          保存
                        </span>
                        <span class="job-num-btn" @click="isEditUser = false">
                          取消
                        </span>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="分销商" prop="companyId">
                  <div class="job-num-box">
                    <p v-if="!isEditCompany">
                      <span v-if="companyStore.company&&companyStore.company.name">{{ companyStore.company.name | nullValue }}</span>
                      <span v-else>—</span>
                    </p>
                    <el-select
                      v-else
                      v-model="companyStore.companyId"
                      filterable
                      remote
                      placeholder="请输入分销商关键词"
                      @focus="getCompany('')"
                      :remote-method="getCompany"
                      :loading="getCompanyLoading"
                      style="width: 200px"
                    >
                      <el-option
                        v-for="item in companyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <div v-if="permissions['Company.Stores.ChangeCompany']">
                      <div
                        v-if="!isEditCompany"
                        class="job-num-btn"
                        @click="isEditCompany = true"
                      >
                        修改分销商
                      </div>
                      <div v-else>
                        <span
                          class="job-num-btn"
                          @click="changeCompany(companyStore.companyId)"
                          >保存</span
                        >
                        <span class="job-num-btn" @click="isEditCompany = false"
                          >取消</span
                        >
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="联系电话" prop="phoneNumber">
                  {{ companyStore.phoneNumber | nullValue }}
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                  {{ companyStore.email | nullValue }}
                </el-form-item>
              </div>
              <!-- 右 -->
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item
                  v-if="companyStore.organizationId"
                  label="分销商门店状态"
                  prop="user"
                >
                  <div class="job-num-box">
                    <p v-if="!isEditStatus">
                      {{ companyStore.statusVal | nullValue }}
                    </p>
                    <el-select
                      v-else
                      v-model="companyStore.status"
                      clearable
                      placeholder="请选择分销商门店状态"
                      style="width: 200px"
                    >
                      <el-option
                        v-for="item in companyStoreStatusOptions"
                        :key="item.value"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                    <div>
                      <div
                        v-if="!isEditStatus"
                        class="job-num-btn"
                        @click="isEditStatus = true"
                      >
                        修改状态
                      </div>
                      <div v-else>
                        <span class="job-num-btn" @click="changeStatus()"
                          >保存</span
                        >
                        <span class="job-num-btn" @click="isEditStatus = false"
                          >取消</span
                        >
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="是否主店" prop="isMaster">
                  {{ companyStore.isMaster ? "是" : "否" }}
                </el-form-item>
                <el-form-item label="分销商门店租金" prop="rent">
                  {{ companyStore.rent | nullValue }}
                </el-form-item>
                <el-form-item label="分销商门店面积" prop="area">
                  {{ companyStore.area | nullValue }}
                </el-form-item>
                <el-form-item label="分销商门店退出方式" prop="dropWay">
                  {{ companyStore.dropWay | nullValue }}
                </el-form-item>
                <el-form-item label="分销商门店退出时间" prop="dropTime">
                  {{ companyStore.dropTime | dayFormat }}
                </el-form-item>
                <el-form-item label="歇业开始时间" prop="closeStartTime">
                  {{ companyStore.closeStartTime | dayFormat }}
                </el-form-item>
                <el-form-item label="歇业结束时间" prop="closeEndTime">
                  {{ companyStore.closeEndTime | dayFormat }}
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <!-- 详细信息 -->
        <div class="basic-item">
          <div v-if="isEditDetail">
            <div class="basic-item-title">详细信息</div>
            <div class="basic-item-main">
              <!-- 左 -->
              <div class="main-item">
                <el-form-item label="营业执照名称" prop="businessName">
                  <el-input
                    v-model="companyStore.businessName"
                    placeholder="请输入营业执照名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="营业执照号码" prop="businessLicense">
                  <el-input
                    v-model="companyStore.businessLicense"
                    placeholder="请输入营业执照号码"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="加盟合同编号">
                  <el-input
                    v-model="companyStore.contractNumber"
                    placeholder="请输入加盟合同编号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="加盟合同生效时间" prop="contractStartTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.contractStartTime"
                    type="date"
                    placeholder="请选择加盟合同生效时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="加盟合同结束时间" prop="contractEndTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.contractEndTime"
                    type="date"
                    placeholder="请选择加盟合同结束时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <!-- 右 -->
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item label="最晚开业核准日期" prop="lastAllowWorkTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.lastAllowWorkTime"
                    type="date"
                    placeholder="请选择最晚开业核准日期"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label="实际开业核准日期"
                  prop="actualAllowWorkTime"
                >
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.actualAllowWorkTime"
                    type="date"
                    placeholder="请选择实际开业核准日期"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="工商注册地址">
                  <el-input
                    v-model="companyStore.registerAddress"
                    placeholder="请输入工商注册地址"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="实际经营地址">
                  <el-input
                    v-model="companyStore.currentAddress"
                    placeholder="请输入实际经营地址"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="submit('basic')"
                >保存</el-button
              >
              <el-button @click="cancel()">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              详细信息
              <div class="basic-edit" @click="isEditDetail = true">管理</div>
            </div>
            <div class="basic-item-main">
              <!-- 左 -->
              <div class="main-item">
                <el-form-item label="营业执照名称" prop="businessName">
                  {{ companyStore.businessName | nullValue }}
                </el-form-item>
                <el-form-item label="营业执照号码" prop="businessLicense">
                  {{ companyStore.businessLicense | nullValue }}
                </el-form-item>
                <el-form-item label="加盟合同编号">
                  {{ companyStore.contractNumber | nullValue }}
                </el-form-item>
                <el-form-item label="加盟合同生效时间" prop="contractStartTime">
                  {{ companyStore.contractStartTime | dayFormat }}
                </el-form-item>
                <el-form-item label="加盟合同结束时间" prop="contractEndTime">
                  {{ companyStore.contractEndTime | dayFormat }}
                </el-form-item>
              </div>
              <!-- 右 -->
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item label="最晚开业核准日期" prop="lastAllowWorkTime">
                  {{ companyStore.lastAllowWorkTime | dayFormat }}
                </el-form-item>
                <el-form-item
                  label="实际开业核准日期"
                  prop="actualAllowWorkTime"
                >
                  {{ companyStore.actualAllowWorkTime | dayFormat }}
                </el-form-item>
                <el-form-item label="工商注册地址">
                  {{ companyStore.registerAddress | nullValue }}
                </el-form-item>
                <el-form-item label="实际经营地址">
                  {{ companyStore.currentAddress | nullValue }}
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <!-- 缴费信息 -->
        <div class="basic-item">
          <div v-if="isEditCharge">
            <div class="basic-item-title">缴费信息</div>
            <div class="basic-item-main">
              <!-- 左 -->
              <div class="main-item">
                <el-form-item label="保证金" prop="deposit">
                  <el-input
                    v-model="companyStore.deposit"
                    placeholder="请输入保证金"
                    clearable
                  ></el-input>
                  <span class="unit">元</span>
                </el-form-item>
                <el-form-item label="加盟费" prop="joinFee">
                  <el-input
                    v-model="companyStore.joinFee"
                    placeholder="请输入加盟费"
                    clearable
                  ></el-input>
                  <span class="unit">元</span>
                </el-form-item>
                <el-form-item label="支付类型" prop="paymentType">
                  <el-select
                    v-model="companyStore.paymentType"
                    clearable
                    placeholder="请选择支付类型"
                  >
                    <el-option
                      v-for="item in companyStorePayMentOptions"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="收费金额" prop="paymentMoney">
                  <el-input
                    v-model="companyStore.paymentMoney"
                    placeholder="请输入收费金额"
                    clearable
                  ></el-input>
                  <span class="unit">元</span>
                </el-form-item>
                <el-form-item label="收费比例" prop="paymentRate">
                  <el-input
                    v-model="companyStore.paymentRate"
                    placeholder="请输入收费比例"
                    type="number"
                    clearable
                  ></el-input>
                  <span class="unit">%</span>
                </el-form-item>
              </div>
              <!-- 右 -->
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item label="特费缴费开始时间" prop="paymentStartTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.paymentStartTime"
                    type="date"
                    placeholder="请选择特费缴费开始时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="特费缴费结束时间" prop="paymentEndTime">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="companyStore.paymentEndTime"
                    type="date"
                    placeholder="请选择特费缴费结束时间"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="收费保底费用" prop="leastPaymentMoney">
                  <el-input
                    v-model="companyStore.leastPaymentMoney"
                    placeholder="请输入收费保底费用"
                    clearable
                  ></el-input>
                  <span class="unit">元</span>
                </el-form-item>
                <el-form-item label="收费政策描述" prop="paymentDescription">
                  <el-input
                    type="textarea"
                    resize="none"
                    :rows="2"
                    placeholder="请输入收费政策描述"
                    v-model="companyStore.paymentDescription"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="submit('basic')"
                >保存</el-button
              >
              <el-button @click="cancel()">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              缴费信息
              <div class="basic-edit" @click="isEditCharge = true">管理</div>
            </div>
            <div class="basic-item-main">
              <!-- 左 -->
              <div class="main-item">
                <el-form-item label="保证金" prop="deposit">
                  {{ companyStore.deposit | nullValue }}元
                </el-form-item>
                <el-form-item label="加盟费" prop="joinFee">
                  {{ companyStore.joinFee | nullValue }}元
                </el-form-item>
                <el-form-item label="支付类型" prop="paymentType">
                  {{ companyStore.paymentTypeVal | nullValue }}
                </el-form-item>
                <el-form-item label="收费金额" prop="paymentMoney">
                  {{ companyStore.paymentMoney | nullValue }}元
                </el-form-item>
                <el-form-item label="收费比例" prop="paymentRate">
                  {{ companyStore.paymentRate | nullValue }}%
                </el-form-item>
              </div>
              <!-- 右 -->
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item label="特费缴费开始时间" prop="paymentStartTime">
                  {{ companyStore.paymentStartTime | dayFormat }}
                </el-form-item>
                <el-form-item label="特费缴费结束时间" prop="paymentEndTime">
                  {{ companyStore.paymentEndTime | dayFormat }}
                </el-form-item>
                <el-form-item label="收费保底费用" prop="leastPaymentMoney">
                  {{ companyStore.leastPaymentMoney | nullValue }}元
                </el-form-item>
                <el-form-item label="收费政策描述" prop="paymentDescription">
                  {{ companyStore.paymentDescription | nullValue }}
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <el-dialog
        title="分销商门店备注"
        :visible.sync="isRemarkShow"
        width="550px"
        custom-class="employe-remark employe-dialog"
      >
        <el-form :model="remarkForm">
          <el-input
            type="textarea"
            v-model="remarkForm.more"
            maxlength="60"
            show-word-limit
            resize="none"
            placeholder="请填写分销商门店备注"
          ></el-input>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isRemarkShow = false">取消</el-button>
          <el-button type="primary" @click="submitRemark">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import baseInfoJs from "./basicInfo.js";
export default {
  ...baseInfoJs,
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";

.header-top {
  position: fixed;
  top: 50px;
  z-index: 99;
  display: none;
  align-items: center;
  height: 60px;

  font-size: 16px;
  font-weight: bold;

  color: #000;
  background-color: #fff;

  .left {
    display: flex;
    align-items: center;

    .header-back {
      display: flex;
      align-items: center;
      justify-content: center;

      margin: 0 23px 0 16px;
      height: 26px;
      width: 26px;
      cursor: pointer;

      &:hover {
        background-color: #f2f2f2;
      }

      .header-svg {
        width: 14px;
        height: 14px;
        color: $--color-primary;
      }
    }

    span {
      position: relative;
      top: -2px;
    }
  }

  .scroll-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    min-width: 949px;

    .left-scroll {
      display: flex;
      align-items: center;
      .head-img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
      }
      .scroll-head {
        width: 28px;
        height: 28px;
        border-radius: 50%;
      }

      .scroll-main {
        display: flex;
        align-items: baseline;

        .scoll-name {
          margin-left: 11px;
          font-size: 20px;
          font-weight: bold;
          color: #000;
        }

        .scroll-post {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 400;
          color: #000;
        }
      }
    }

    .right-scroll {
      display: flex;
      justify-content: space-between;

      .el-button {
        color: $--color-primary;
        border-color: $--color-primary;
      }
    }
  }
}

.header-visible {
  display: flex;
}

.box-shadow {
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
  border-radius: $--border-radius-base;
}
::v-deep .employe-dialog {
  .el-dialog__header {
    padding: 25px 25px 20px 25px;
  }

  .el-dialog__footer {
    padding: 15px 25px 25px 25px;

    .upload-btn {
      margin-right: 10px;
    }
  }
}
@media (max-width: 1367px) {
  .header-top {
    margin-left: -20px;

    .scroll-box {
      left: 20px;
    }
  }
}

@media (min-width: 1367px) and (max-width: 1920px) {
  .header-top {
    margin-left: -100px;

    .scroll-box {
      left: 100px;
    }
  }
}

@media (min-width: 1920px) {
  .header-top {
    margin-left: -180px;

    .scroll-box {
      left: 180px;
    }
  }
}

.basic-info {
  text-align: left;
  min-width: 949px;
  position: relative;

  .basic-head {
    margin-bottom: 20px;
    padding: 24px 24px 20px;
    background: #fff;
    // box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    border-radius: $--border-radius-base;

    .head-main {
      display: flex;
      position: relative;
      width: 100%;
      height: 165px;

      .main-left {
        border-radius: $--border-radius-base;
        width: 100%;
        display: flex;

        .head-box {
          position: relative;
          margin-right: 20px;
          width: 142px;
          height: 100%;

          .head-btn {
            display: none;
            justify-content: center;
            align-items: center;

            position: absolute;
            left: 0;
            bottom: 0;

            width: 100%;
            height: 40px;

            font-size: 12px;
            font-weight: 400;
            color: #fff;
            background: rgba(0, 0, 0, 0.4);
            cursor: pointer;
          }
          .head-loading {
            bottom: -20px;
            position: absolute;
            left: 0;
          }
          &:hover .head-btn {
            display: flex;
          }

          .head-img {
            width: 100%;
            height: 100%;
            // border:1px solid #666;
            box-shadow: 0px 0px 1px 0 rgba(0, 0, 0, 0.2);
          }
        }
        ::v-deep .el-image .image-slot {
          width: 100%;
          height: 100%;
          background: #f5f7fa;
          color: #909399;
          font-size: 30px;
          @include flex(row, center);
          justify-content: center;
        }

        .head-items {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          padding: 7px 0;
          width: calc(100% - 162px);
          font-size: 14px;
          font-weight: 400;
          color: #000;

          .head-tags {
            display: flex;
            align-items: center;
            height: 34px;
            width: 100%;
          }

          .head-item {
            display: flex;
            align-items: center;

            .basic-name {
              margin-right: 5px;
              font-size: 20px;
              font-weight: bold;
              color: #000;
            }

            .medal-img {
              margin: 2px 5px 0 1px;
              width: 16px;
              height: 22px;
            }

            .job-num {
              align-self: flex-end;
              margin-left: 5px;
            }

            .tags-items {
              display: flex;
              align-items: center;
              margin-right: 4px;

              .tag {
                margin-right: 6px;
                padding: 6px 12px;
                white-space: nowrap; /* 不换行 */
                background: #f2f2f2;
              }
            }

            .tag-btn {
              white-space: nowrap; /* 不换行 */
              color: $--color-primary;
              cursor: pointer;
            }
          }

          .tags-box {
            align-items: center;
          }

          .tags-input {
            display: flex;
            align-items: center;
            width: 100%;

            .input-box {
              display: flex;
              align-items: center;
              width: calc(100% - 34px);

              padding: 0 9px;
              border: 1px solid #ddd;
              height: 34px;
              box-sizing: border-box;

              .tag {
                display: flex;
                align-items: center;

                margin-right: 6px;
                padding: 0 12px;
                height: 24px;
                background: #f2f2f2;

                .tag-text {
                  white-space: nowrap; /* 不换行 */
                }

                .svg-icon {
                  margin-left: 10px;
                  cursor: pointer;
                }
              }

              .el-input {
                width: 200px;
                ::v-deep .el-input__inner {
                  padding: 0;
                  border-color: transparent;
                }
              }
            }

            .input-btn {
              margin-left: 10px;
              color: $--color-primary;
              white-space: nowrap; /* 不换行 */
              cursor: pointer;
            }
          }
        }
      }

      .z-index {
        z-index: 3;
      }

      .main-right {
        border-radius: $--border-radius-base;
        position: absolute;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        box-sizing: border-box;
        padding: 5px 0 8px;
        height: 100%;
        z-index: 2;

        .right-items {
          display: flex;
          justify-content: space-between;

          width: 318px;
          color: #444;
          text-align: center;

          .item-value {
            margin-top: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #ff9900;
          }

          .quitted {
            color: #ec5050;
          }
        }

        .right-btns {
          display: flex;
          justify-content: space-between;

          .el-button {
            color: $--color-primary;
            border-color: $--color-primary;
          }
        }
      }
    }

    .head-line {
      margin: 25px 0 12px;
      width: 100%;
      height: 1px;
      background: #ddd;
    }

    .head-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .svg-icon {
        cursor: pointer;
      }

      .bottom-left {
        display: flex;
        align-items: center;
        cursor: pointer;

        .mark-box {
          margin-left: 10px;
        }
      }

      .bottom-right {
        display: flex;
        justify-content: space-between;
        width: 18px;
        font-size: 16px;
      }
    }
  }

  .to-audit {
    margin-bottom: 20px;
    border: 1px solid #97c7ff;
    padding: 10px 20px;

    font-size: 12px;
    font-weight: 400;

    color: #003b80;
    background: #e5f0ff;

    .audit-top {
      font-size: 12px;
      font-weight: bold;
      color: rgba(0, 59, 128, 1);
    }

    .audit-item-btn {
      color: $--color-primary;
      cursor: pointer;
    }
  }

  .basic-item {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;
    background: #fff;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    ::v-deep .el-date-editor {
      .el-input__inner {
        padding-left: 30px;
      }
      .el-icon-circle-close {
        right: 0;
      }
    }
    .post-symbol {
      color: #f56c6c;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .basic-item-title {
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }

    .add-position {
      margin-bottom: 10px;
    }

    .basic-title-edit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .basic-edit {
        font-size: 14px;
        font-weight: 400;
        color: $--color-primary;
        cursor: pointer;
      }
    }

    .basic-item-main {
      display: flex;

      .main-item {
        width: 50%;

        .unit {
          padding-left: 10px;
        }
        .edit-group {
          display: flex;
          .edit {
            color: $--color-primary;
          }
        }
        .el-select,
        .el-input,
        .el-textarea {
          width: 330px;
        }

        .work-card {
          .work-card-item {
            display: flex;
            align-items: flex-end;
            margin-bottom: 15px;
            line-height: 0;

            .default-img,
            .work-card-img {
              margin-right: 10px;
              width: 143px;
              height: 148px;
            }

            .upload-btn {
              border: 1px solid rgba(221, 221, 221, 1);
              width: 110px;
              height: 30px;
              font-size: 12px;
              font-weight: 400;
              color: #000;
            }
          }

          .work-card-print {
            margin-bottom: 0;
          }

          .upload-tip {
            font-size: 12px;
            font-weight: 400;
            color: #888;
            line-height: 0;
          }
        }

        .encrypt-number {
          display: flex;

          span {
            display: inline-block;
            width: 115px;
          }

          .show-svg {
            margin-left: 8px;

            .svg-icon {
              margin-top: -2px;
              cursor: pointer;
            }
          }
        }

        .phone-number {
          span {
            width: 75px;
          }
        }

        .job-num-box {
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: #000;
          vertical-align: middle;

          p {
            margin: 0;
          }

          .job-num-btn {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: $--color-primary;
            cursor: pointer;
          }

          .el-input {
            width: 200px;
          }
        }

        .account-lock {
          display: inline-block;
          margin-right: 5px;
        }

        .lockout-box {
          display: flex;
          align-items: center;

          .svg-icon {
            margin-right: 5px;
          }
        }

        .is-lockout {
          color: #f44242;
        }

        .not-lockout {
          color: #0abf5b;
        }

        .work-age {
          display: flex;
          width: 330px;

          .el-input {
            width: 50%;
            &:first-child {
              ::v-deep .el-input-group__append {
                border-right-color: transparent;
              }
            }
          }
        }

        ::v-deep .el-form-item__content {
          .el-radio__label {
            display: inline-block;
            width: 60px;
          }
          .el-input-group {
            vertical-align: baseline;
          }
        }
      }

      .basic-item-right {
        padding-left: 50px;
      }
    }

    .basic-main-edit {
      margin-bottom: -20px;
      border-bottom: 0;

      .el-form-item {
        height: 30px;
        margin-bottom: 14px;
      }
    }

    .el-table {
      margin-bottom: 25px;
      .table-empty {
        color: $--color-primary;
        cursor: pointer;
      }
      .grade-box {
        display: flex;
        align-items: baseline;

        .grade-main {
          margin-left: 9px;
          border: 1px solid $--color-primary;
          padding: 0 5px;

          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          color: $--color-primary;
        }
      }
    }
  }

  .group-btn {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ddd;
  }

  .up-top {
    right: -70px;
    bottom: -20px;
  }

  .employe-remark {
    .el-form {
      margin-bottom: 15px;

      .el-textarea {
        width: 464px;
      }
    }

    .lock-info {
      margin-bottom: 20px;
      color: #e6a23c;
    }
  }

  .el-dialog {
    .dialog-tip {
      margin-top: -3px;
      width: 504px;

      font-size: 12px;
      font-weight: 400;
      line-height: 18px;

      color: #e6a23c;
    }

    .regular-date {
      margin-top: -5px;
    }

    .margin-bottom {
      margin-bottom: 22px;
    }
  }

  .lock-dialog {
    .el-form {
      .el-textarea {
        width: 440px;
      }
    }
  }

  .regular-dialog {
    .select-inline,
    .el-textarea,
    .el-select,
    .el-date-editor {
      width: 404px;

      ::v-deep .el-icon-date {
        left: 368px;
      }
    }

    .select-inline {
      .el-form-item {
        width: 50%;
        .el-select {
          width: 100%;
        }
      }

      .work-days {
        ::v-deep .el-input__inner {
          &:focus {
            border-color: #ddd;
          }
        }

        &:hover,
        &:focus {
          ::v-deep .el-input__inner {
            border-color: #ddd;
          }
        }
      }

      .induction-status {
        ::v-deep .el-input__inner {
          border-right-color: transparent;
          &:focus {
            border-color: #ddd;
            border-right-color: transparent;
          }
        }
        &:hover,
        &:focus {
          ::v-deep .el-input__inner {
            border-color: #ddd !important;
          }

          & + .work-days {
            ::v-deep .el-input__inner {
              border-left-color: transparent;
            }
          }
        }
      }

      .custom-width {
        width: 100%;
      }
    }
  }

  .dimission-dialog {
    .el-select {
      width: 396px;
    }
  }

  ::v-deep .employe-position {
    .el-dialog__header {
      padding: 25px 25px 20px 25px;
    }

    .el-dialog__body {
      padding: 0 25px;

      .el-input,
      .el-select,
      .el-textarea {
        width: 396px;
      }

      .vue-treeselect__input-container {
        height: 28px;
      }

      .vue-treeselect__menu {
        width: 350px;
      }
    }

    .el-dialog__footer {
      padding: 15px 25px 25px 25px;
    }
  }

  @media (max-width: 1365px) {
    .up-top {
      display: none;
    }
  }

  @media (min-width: 1440px) and (max-width: 1680px) {
    .table-operation {
      width: 200px;
    }
  }

  @media (min-width: 1680px) {
    .table-operation {
      width: 250px;
    }
  }
}

.encrypt-number {
  display: flex;
  align-items: center;

  span {
    display: inline-block;
    width: 160px;
  }

  .show-svg {
    .svg-icon {
      margin-top: 1px;
      cursor: pointer;
    }
  }
}
.svg-num {
  padding-right: 10px;
  display: inline-block;
  width: 70px;
}
.svg-look {
  display: inline-block;
  cursor: pointer;
}
</style>